import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", y = 40 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const SectionHead = ({ num, title, sub, testid }) => (
  <div className="mb-14 md:mb-20" data-testid={testid}>
    <Reveal>
      <div className="flex items-end gap-5">
        <span className="num-outline font-display text-6xl md:text-8xl leading-none select-none">{num}</span>
        <span className="mb-3 h-px flex-1 bg-white/10" />
      </div>
    </Reveal>
    <Reveal delay={0.1}>
      <h2 className="mt-4 font-display text-4xl sm:text-5xl lg:text-6xl uppercase tracking-wide">{title}</h2>
    </Reveal>
    {sub && (
      <Reveal delay={0.18}>
        <p className="mt-4 max-w-2xl text-sm md:text-base text-neutral-400">{sub}</p>
      </Reveal>
    )}
  </div>
);
